{
	"choosePhotoToEdit": "Choose a photo to edit, then mark it as Reference to start using your AI Style."
}
